<template>
  <div class="booking-special-data-grid">
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="finalRowData"
      style="width:100%;height:200px;margin-bottom: 5px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <div v-show="isEdit" style="width:100%">
      <div style="text-align:right;margin-bottom:5px">
        <el-button no="Add" type="primary" @click="add">{{ $t('SeaExport.Add') }}</el-button>
        <el-button no="Delete" type="danger" @click="remove">{{ $t('SeaExport.Delete') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { EQ_SIZES, EQ_SIZES_3 } from '@/class/cargo/model/parameters/EQSize'
import { SeaEQ } from '@/class/model/booking/SeaEQ'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import uidUtil from '@/utils/uidUtil'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'

export default {
  name: 'BookingSpecialDataGrid',
  props: {
    job: { type: Object, required: true },
    value: { type: Array, default: () => [] },
    isEdit: { type: Boolean, required: true },
    hideEqType: { type: Boolean, default: false },
    hideSoc: { type: Boolean, default: false }
  },
  data() {
    return {
      eqSizes: EQ_SIZES,
      gridOptions: {
        rowSelection: 'single',
        suppressContextMenu: true,
        suppressCellSelection: true,
        rowHeight: 32,
        context: {
          componentParent: this
        }
      },

      rowData: [],
      gridApi: null
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 70,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'cargo-cell-select',
            optionField: {
              label: 'name',
              value: 'code',
              filterable: false
            },
            attrs: {
              cellSelectAttrs: { fullOptions: [... this.eqSizes] }
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 70,
          hide: this.hideEqType,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'cargo-advance-select',
            selectType: TYPE_NAMES.basic_data_EQType,
            tagValue: 'code',
            tagName: 'code',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerAmount'),
          field: 'eqQuantity',
          width: 70,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            precision: 0,
            min: 0,
            tag: 'el-input-number',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: 'SOC',
          field: 'soc',
          width: 70,
          hide: this.hideSoc,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'el-checkbox',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.Dimension'),
          field: '',
          width: 220,
          cellRendererFramework: 'agGridColumnEditGroup',
          custom: {
            isEdit: false,
            childs: [
              {
                field: 'sizeLength',
                tag: 'el-input-number'
              },
              {
                tag: 'span',
                attrs: {
                  style: 'font-size:18px;line-height:32px'
                },
                text: '*'
              },
              {
                field: 'sizeWidth',
                tag: 'el-input-number'
              },
              {
                tag: 'span',
                attrs: {
                  style: 'font-size:18px;line-height:32px'
                },
                text: '*'
              },
              {
                field: 'sizeHeight',
                tag: 'el-input-number'
              }
            ]
          }
        }
      ]
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    }
  },
  watch: {
    value(newVal) {
      this.rowData = newVal
    },
    isEdit(newVal) {
      for (const item of this.columnDefs) {
        if (item.custom instanceof Object) {
          item.custom.isEdit = this.isEdit
        }
      }
    }
  },
  created() {
    if (this.job.lob === 'RI' || this.job.lob === 'RE') {
      this.eqSizes = EQ_SIZES_3
    }
    this.rowData = this.value
    for (const item of this.columnDefs) {
      if (item.custom instanceof Object) {
        item.custom.isEdit = this.isEdit
      }
    }
  },
  methods: {
    add() {
      let eqSize = ''
      if (this.rowData.length === 0) {
        eqSize = '20'
      } else {
        for (const item of this.eqSizes) {
          let isExist = false
          for (const subItem of this.rowData) {
            if (subItem.eqType === 'GP' && subItem.eqSize === item.code) {
              isExist = true
              break
            }
          }
          if (!isExist) {
            eqSize = item.code
            break
          }
        }
      }
      if (!eqSize) {
        this.$message.warning(this.$t('Message.ASameBoxTypeExists'))
        return
      }
      const row = new SeaEQ().fillDefaultValue().getData()
      row.eqSize = eqSize
      row.eqType = 'GP'
      row.eqQuantity = 1
      if (this.job.masterFlag) {
        row.joinContainerId = uidUtil.createUID()
      }
      row.jobUuid = this.job.uuid
      this.rowData.push(row)
      this.$nextTick(() => {
        this.gridApi.deselectAll()
        const nodes = this.gridApi.getRenderedNodes()
        const lastNode = nodes[nodes.length - 1]
        lastNode.setSelected(true)
      })

      this.job.seaEQ = this.rowData // 指向同一个 seaEQ
      // 装箱信息
      if (this.job.masterFlag) {
        ContainerUtil.autoAdjustMasterContainer(this.job)
      } else {
        ContainerUtil.autoJustContainerUsages(this.job)
      }
      this.eqQuantityChange()
    },
    remove() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.finalRowData[cell.rowIndex] : null
      if (row) {
        if (row.uuid) {
          // 检查: 已输入箱型箱种信息不能删
          if (this.job.masterFlag && !ContainerUtil.checkCanDelSeaEQ(row, this.job)) {
            this.$message.info(this.$t('Message.ContainerSealInfoHasBeenEnteredCannotBeDeleted'))
            return
          }
          // 检查该箱型箱种能删的数量
          if (!this.job.masterFlag && !ContainerUtil.checkInputContainerNo(row, this.job)) {
            this.$message.info(this.$t('Message.ContainerSealInfoHasBeenEnteredCannotBeDeleted'))
            return
          }
          row.deleted = true
          /* 强制刷新finalRowData */
          // const tempRowData = this.rowData
          // this.rowData = []
          // this.$nextTick(() => {
          //   this.rowData = tempRowData
          // })
          const index = this.rowData.findIndex(p => p.uuid === row.uuid)
          if (index > -1) {
            this.rowData.splice(index, 1)
          }
          if (!this.job.delseaEQUuids) {
            this.job.delseaEQUuids = []
          }
          this.job.delseaEQUuids.push(row.uuid)
          // 更新装箱信息中的箱型信息
          if (this.job.masterFlag) {
            ContainerUtil.autoAdjustMasterContainer(this.job)
          } else {
            ContainerUtil.autoJustContainerUsages(this.job)
          }
        } else {
          const index = this.rowData.findIndex(p => p === row)
          if (index > -1) {
            this.rowData.splice(index, 1)
          }
        }
        this.eqQuantityChange()
      }
    },
    onCellChange(params) {
      this.$emit('cellChange', params)

      // 装箱信息 （soc 编辑不影响container,usages 增删改）
      if (params.field !== 'soc') {
        if (this.job.masterFlag) {
          ContainerUtil.autoAdjustMasterContainer(this.job)
        } else {
          ContainerUtil.autoJustContainerUsages(this.job)
        }
      }

      // soc状态改变
      if (params.field === 'soc') {
        if (this.job.containers) {
          for (const c of this.job.containers) {
            if (c.eqType === params.data.eqType && c.eqSize === params.data.eqSize && c.containerUsage) {
              for (const usage of c.containerUsage) {
                usage.soc = params.data.soc
              }
            }
          }
        }
      }
      this.eqQuantityChange()
    },
    eqQuantityChange() {
      if (SEUtils.needTip(this.job, 'CNTR')) {
        this.$confirm(this.$t('Message.IfToRefreshTheContainers'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(async() => {
          this.$emit('eqQuantityChange')
        })
      }
    }
  }
}
</script>

<style lang="scss">
.booking-special-data-grid {
  .ag-header-cell-text {
    color: #4283ff;
    font-weight: bold;
  }
}
</style>
